import './style.scss'
export default function InfoBlock2() {
    return <div id="info" className="info-block-2">
        <div className="info-block-2__wrapper container">
            <div className="info-block-2__top" data-aos="fade-up">
                <h2 className="info-block-2__title title">Digital or Traditional — You Decide.</h2>
                <span className="info-block-2__subtitle">We help clients assess and integrate digital assets — safely, strategically, and with clarity.</span>
            </div>

            <div className="info-block-2__columns">

                <div className="info-block-2__column" data-aos="fade-up">
                    <h3 className="info-block-2__column-title">Crypto & Blockchain</h3>
                    <p>We provide comprehensive consulting in digital assets, helping you navigate the complexities of the crypto market. <br/> <br/>
                        Our team evaluates both short-term volatility and long-term potential, so you can make informed decisions — not speculative ones. <br/> <br/>
                        We ensure your digital assets fit your portfolio with full transparency and risk control.</p>
                    <a href="#" className="button">Open account</a>
                </div>

                <div className="info-block-2__column" data-aos="fade-up">
                    <h3 className="info-block-2__column-title">Funds, Bonds & Indexes</h3>
                    <p>For investors who prefer time-tested instruments, we offer carefully structured solutions built on proven financial logic. <br/> <br />
                        Our classic strategies include bond ladders, index fund allocations, and ETF blends — all optimized for long-term performance and capital preservation. <br/> <br/>
                        This approach is ideal for those seeking stable returns with minimal exposure to market turbulence.</p>
                    <a href="#" className="button">Open account</a>
                </div>

            </div>
        </div>
    </div>
}